<template>
  <div class="user-detail-integral-detail">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailIntegralDetailInfo.details" border style="width: 100%">
        <el-table-column prop="detailId" :label="$t('userDetailIntegralDetail.id')" align="center">
        </el-table-column>
        <el-table-column prop="integralName" :label="$t('userDetailIntegralDetail.accountName')" align="center">
        </el-table-column>
        <el-table-column prop="integralId" :label="$t('userDetailIntegralDetail.accountId')" align="center">
        </el-table-column>
        <el-table-column prop="detailType" :label="$t('userDetailIntegralDetail.type')" align="center">
          <template slot-scope="scope">
            {{ scope.row.detailType === '2002' ? $t('userDetailIntegralDetail.transferOut') :
              $t('userDetailIntegralDetail.transferIn') }}
          </template>
        </el-table-column>
        <el-table-column prop="relIntegralId" :label="$t('userDetailIntegralDetail.relatedAccount')" align="center">
        </el-table-column>
        <el-table-column prop="amount" :label="$t('userDetailIntegralDetail.integralAmount')" align="center">
        </el-table-column>
        <el-table-column prop="objType" :label="$t('userDetailIntegralDetail.objType')" align="center">
          <template slot-scope="scope">
            {{ scope.row.objType === '7007' ? $t('userDetailIntegralDetail.merchant') :
              $t('userDetailIntegralDetail.user') }}
          </template>
        </el-table-column>
        <el-table-column prop="objId" :label="$t('userDetailIntegralDetail.objId')" align="center">
        </el-table-column>
        <el-table-column prop="link" :label="$t('userDetailIntegralDetail.tel')" align="center">
        </el-table-column>
        <el-table-column prop="orderId" :label="$t('userDetailIntegralDetail.orderNo')" align="center">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('userDetailIntegralDetail.transactionTime')" align="center">
        </el-table-column>
        <el-table-column prop="remark" :label="$t('userDetailIntegralDetail.remark')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getIntegralDetailList } from '@/api/user/userDetailIntegralDetailApi'

export default {
  name: 'UserDetailIntegralDetail',
  data() {
    return {
      userDetailIntegralDetailInfo: {
        details: [],
        link: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
   
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailIntegralDetailInfo.link = data.tel
      this.loadIntegralDetailData()
    },
    loadIntegralDetailData() {
      const params = {
        link: this.userDetailIntegralDetailInfo.link,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getIntegralDetailList(params).then(res => {
        this.userDetailIntegralDetailInfo.details = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadIntegralDetailData()
    }
  }
}
</script>

<style scoped>
.user-detail-integral-detail {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>